// extracted by mini-css-extract-plugin
module.exports = {"featured-all__artist":"featured-all_featured-all__artist__8mH5d","featured-all__card-details":"featured-all_featured-all__card-details__SrvW4"};